export const DASHBOARD_GET_KEYCODES = 'DASHBOARD_GET_KEYCODES';
export const DASHBOARD_GET_ASSIGNED_KEYCODES = 'DASHBOARD_GET_ASSIGNED_KEYCODES';
